/**
 *
 * @module createPaymentResponse
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class CreatePaymentMethodPassthroughData
 *
 */
export default class CreatePaymentMethodResponse {

    /**
     *
     * @param {String} paymentMethodId
     * @throws {InvalidArgumentException}
     *
     */
    constructor(paymentMethodId) {

        const errorMessage = {
            ctor: 'CreatePaymentMethodResponse(paymentMethodId)',
            get paymentMethodId() {
                return `${this.ctor} paymentMethodId shoudld be a String with length`;
            }
        };

        nonEmptyString(paymentMethodId, errorMessage.paymentMethodId, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.paymentMethodId = paymentMethodId;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/createPaymentMethodResponse.js